import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import debounce from '../../helpers/debounce';

export default function FooterLink({ url, label, lastLink, handleOverflow }) {
  const linkRef = useRef(null);
  let qaidLabel = label;

  qaidLabel = qaidLabel.replace(/\s/g, '');

  // the number 19 is based off the font size of the link
  // if the font size changes, this value must also be changed
  useEffect(() => {
    function calculateOverflow() {
      if (linkRef?.current?.offsetHeight !== undefined && linkRef?.current?.offsetHeight > 19) {
        handleOverflow(lastLink && lastLink.url !== url ? lastLink.url : url);
      }
    }

    const debouncedResize = debounce(calculateOverflow, 200);

    calculateOverflow();
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, [handleOverflow, lastLink, url]);

  return (
    <a
      href={url}
      id={`qaid${qaidLabel}FooterLink`}
      target="_blank"
      rel="noopener noreferrer"
      className="footer-link"
      ref={linkRef}
    >
      {label}
    </a>
  );
}

FooterLink.propTypes = {
  handleOverflow: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  lastLink: PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};
